export const SUPPORTED_SOCIAL_PLATFORMS = [
	"youtube",
	"tiktok",
	"instagram",
	"facebook",
	"linkedin",
	"x",
] as const;

export type SupportedSocialPlatform = (typeof SUPPORTED_SOCIAL_PLATFORMS)[number];

export const SUPPORTED_SOCIAL_PLATFORM_SET = new Set<string>(
	SUPPORTED_SOCIAL_PLATFORMS,
);

export function normalizeSocialPlatformKey(platform: string): string {
	return platform.trim().toLowerCase().replace(/[\s-]+/g, "_");
}
